import { cn } from "utils";

export interface TableCellProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
  children?: React.ReactNode;
}

export const TableCell: React.FC<TableCellProps> = ({
  className,
  children,
  ...props
}) => (
  <div
    className={cn(
      "bg-background_solid_secondary py-1.5 px-2 h-13",
      "body_medium_m text-content_primary",
      "flex items-center",
      className,
    )}
    {...props}
  >
    {children}
  </div>
);
